<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>{{ props.title }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn color="secondary" @click="showForm = false" v-if="showForm">
            Volver a la Lista
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!showForm">
        <v-col cols="12">
          <BuzonList
            @delete="openDeleteModal"
            @newItem="newItem"
            @editItem="editItem"
          />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <BuzonForm :id="itemId" @saved="saved" />
        </v-col>
      </v-row>

      <!-- Modal de confirmación para eliminar buzón -->
      <v-dialog v-model="deleteModal" max-width="400px">
        <v-card>
          <v-card-title class="headline">Confirmar eliminación</v-card-title>
          <v-card-text>
            ¿Está seguro de que desea eliminar este buzón?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteModal = false"
              >Cancelar</v-btn
            >
            <v-btn color="red darken-1" text @click="confirmDelete"
              >Eliminar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useBuzonesStore } from '@/stores/buzonesStore'
import BuzonForm from '@/components/buzones/BuzonForm.vue'
import BuzonList from '@/components/buzones/BuzonList.vue'
import { userIsRecepcion } from '@/utils/helpers'
import { defineProps } from 'vue'

// Define props for the component
const props = defineProps({
  title: {
    type: String,
    required: true
  }
})
const buzonesStore = useBuzonesStore()

const showForm = ref(false)
const itemId = ref(-1)

// Variables para el modal de eliminación
const deleteModal = ref(false)
const itemToDelete = ref(null)

// async function loadBuzones() {
//   try {
//     await buzonesStore.fetchBuzones()
//   } catch (error) {
//     console.error('Error al cargar buzones:', error)
//   }
// }

function newItem() {
  showForm.value = true
  itemId.value = 0
}

function editItem(item) {
  itemId.value = item.id
  showForm.value = true
}

function openDeleteModal(item) {
  itemToDelete.value = item
  deleteModal.value = true
}

async function confirmDelete() {
  try {
    await buzonesStore.deleteBuzon(itemToDelete.value.id)
    // await loadBuzones()
    deleteModal.value = false
  } catch (error) {
    console.error('Error al eliminar buzón:', error)
  }
}

async function saved() {
  showForm.value = false
  // await loadBuzones()
}
</script>
